import { render } from "./addressChoose.vue?vue&type=template&id=399d6cc9"
import script from "./addressChoose.vue?vue&type=script&lang=js"
export * from "./addressChoose.vue?vue&type=script&lang=js"
script.render = render

export default script